// removed by extract-text-webpack-plugin
module.exports = {"tableWrapper":"tableWrapper__3LmoH","paginationWrapper":"paginationWrapper__1Yzla","contWrapper":"contWrapper__24vIA","pageSizeWrapper":"pageSizeWrapper__1J7sf","navigationWrapper":"navigationWrapper__w62VV","paginationDisabled":"paginationDisabled__13w9K"};


//////////////////
// WEBPACK FOOTER
// ./components/table/style.css
// module id = ukti
// module chunks = 0